/**
 * Renders a details panel for a player, showing their position, record and first game
 */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const processDetailsData = (jsonData) => {
  return jsonData;
};

const DetailsPanel = () => {
  const { playerId } = useParams();
  const [data, setData] = useState(undefined);

  useEffect(() => {
    setData(undefined);

    // Fetch details data from API
    fetch(`${process.env.REACT_APP_BUIHA_API_URL}/player/${playerId}/details/`)
      .then((response) => response.json())
      .then((json) => {
        let data = processDetailsData(json);

        setData(data);
      })
      .catch((error) => console.error(error));
  }, [playerId]);

  return data ? (
    <>
      {/* POSITION */}
        <div className="flex flex-row justify-left items-center mb-0.5">
          <img
            src="/assets/position.webp"
            alt="Trophy"
            className="w-4 h-4 mr-2"
            style={
              window.matchMedia &&
              window.matchMedia("(prefers-color-scheme: dark)").matches
                ? { filter: "brightness(0) invert(1)" }
                : {}
            }
          />
          <p className="leading-tight max-xs:text-xs">
            Position: {data.profile.position ? data.profile.position : "-"}
          </p>
        </div>

      {/* RECORD */}
      <div className="flex flex-row justify-left items-center mb-0.5">
        <img
          src="/assets/win.webp"
          alt="Trophy"
          className="w-3 ml-0.5 h-4 mr-2.5 my-0.5"
          style={
            window.matchMedia &&
            window.matchMedia("(prefers-color-scheme: dark)").matches
              ? { filter: "brightness(0) invert(1)" }
              : {}
          }
        />
        <p className="leading-tight max-xs:text-xs">
          Record: {data.record.w}-{data.record.l}-{data.record.d}
        </p>
      </div>

      {/* FIRST GAME */}
      <div className="flex flex-row justify-left items-center mb-0.5">
        <img
          src="/assets/history.webp"
          alt="Trophy"
          className="w-4 h-4 mr-2"
          style={
            window.matchMedia &&
            window.matchMedia("(prefers-color-scheme: dark)").matches
              ? { filter: "brightness(0) invert(1)" }
              : {}
          }
        />
        <p className="leading-tight max-xs:text-xs">
          First Game: {data.first_game ? data.first_game.date : "-"}
        </p>
      </div>
    </>
  ) : (
    // Loading state
    <>
      <div className="flex flex-row justify-left items-center mb-0.5">
        <img
          src="/assets/position.webp"
          alt="Trophy"
          className="w-4 h-4 mr-2"
          style={
            window.matchMedia &&
            window.matchMedia("(prefers-color-scheme: dark)").matches
              ? { filter: "brightness(0) invert(1)" }
              : {}
          }
        />

        <p className="leading-tight dark-text">Position: </p>
      </div>

      <div className="flex flex-row justify-left items-center mb-0.5">
        <img
          src="/assets/win.webp"
          alt="Trophy"
          className="w-3 ml-0.5 h-4 mr-2.5 my-0.5"
          style={
            window.matchMedia &&
            window.matchMedia("(prefers-color-scheme: dark)").matches
              ? { filter: "brightness(0) invert(1)" }
              : {}
          }
        />
        <p className="leading-tight max-xs:text-xs">Record: </p>
      </div>

      <div className="flex flex-row justify-left items-center mb-0.5">
        <img
          src="/assets/history.webp"
          alt="Trophy"
          className="w-4 h-4 mr-2"
          style={
            window.matchMedia &&
            window.matchMedia("(prefers-color-scheme: dark)").matches
              ? { filter: "brightness(0) invert(1)" }
              : {}
          }
        />
        <p className="leading-tight max-xs:text-xs">First Game: </p>
      </div>
    </>
  );
};

export default DetailsPanel;
